import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar } from '@ionic/react';

//import { Bluefin_Hotel_context } from '../../../storeState/bluefin_hotel_context';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import './Reservation_EnterBookingInfo_locals.css';
import '../../../pages/zPublic/css/zPublic.css'
//import { GetGuestSearchMatch } from './GetGuestSearchMatch';
//import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { SelectRoom } from './SelectRoom_locals';
import { PayModal } from './Modal_Pay_locals';
import { ConfirmationManual } from './Confirmation_manual_locals';


export function Reservation_EnterBookingInfo (props) {

    //let authenticatedMerchent_context = useContext(Auth_MerchantID_context);
    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);
    const [companyID, setCompanyID ] = useState(props.data.companyId);
    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);


    let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    let [numOfNights, setNumOfNights] = useState(0);

    let [checkIn_Non_Member_ID_Type, setCheckIn_Non_Member_ID_Type] = useState('drivers_license')
    let [checkInMemberPaymentType, setCheckInMemberPaymentType ] = useState('cash');
    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('cash');
    let [checkInCustomerStatus, setCheckInCustomerStatus ] = useState('non_member');
    //let [checkInAttachment, setCheckInAttachment ] = useState(null);
    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(null);

    let [ccInfoDisplay, setCCInfoDisplay ] = useState('none');
    let [mmInfoDisplay, setMMInfoDisplay ] = useState('none');
    let [checkingInfoDisplay, setCheckingInfoDisplay ] = useState('none');
    let [cashInfoDisplay, setCashInfoDisplay ] = useState('inline-block');

    let [ bookingType, setBookingType ] = useState(null);
    let [checkInRoomID, setCheckInRoomID] = useState(props.data.roomID);
    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(null);

    let [bookingPrice, setBookingPrice] = useState(0.00);

    let [roomSalePrice, setRoomSalePrice] = useState(props.data.roomSalePrice);
    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);

    let [ openPayModal, setOpenPayModal] = useState(false);

    let [paymentAmount, setPaymentAmount] = useState('');
    let [mobileNumber, setMobileNumber] = useState('');
    let [errorMessage_payAmount, setErrorMessage_payAmount] = useState('');
    let [errorMessage, setErrorMessage] = useState('');

    //let selectCheckInDateRef = useRef();
    //let selectCheckOutDateRef = useRef();


    let enterQavaNumberRef = useRef(null);

    let enterMemberPaymentAmountRef = useRef();
    let enterFirstNameRef = useRef();
    let enterLastNameRef = useRef();
    let enterMobileNumberRef = useRef();
    let enterEmailRef = useRef();

    let enterID_numberRef = useRef('00000');
    
    let enterCC_numberRef = useRef();
    let enterCC_expDateRef = useRef();
    let enterCC_cvvNumberRef = useRef();
    let enterCC_addressRef = useRef();
    let enterCC_cityRef= useRef();
    let enterCC_stateRef = useRef();
    let enterCC_zipRef = useRef();
    let enterCC_nonMember_amountRef = useRef();

    let enterMM_displayRef = useRef();
    let selectMobileMoneyProviderRef = useRef();
    let enterMM_phoneNumberRef = useRef();
    let enterMM_nonMember_amountRef = useRef();


    let enterChecking_displayRef = useRef();
    let enterChecking_bankNameRef = useRef();
    let enterChecking_accountNumberRef = useRef();
    let enterChecking_routingNumberRef = useRef();
    let enterChecking_nonMember_amountRef = useRef();

    let enterCash_displayRef = useRef();
    let enterCash_amountRef = useRef();


    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {
    
            //alert(data);
            //alert(JSON.stringify(data));
    
            const blobUrl = URL.createObjectURL(data);
    
            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setCheckInAttachment_ID(noImageFile);
    
            //alert("No Attachment Option checked");
    
        })
    }
    
    useEffect(() => {
    
        //alert('in Use Effect - attachement');
        //alert (checkInAttachment_ID);
    
        handleEnterAttachement();
    
    }, [])


function confirmGuestBooking(event)
{
    setOpenPayModal(false);

    let activeAcctID;

    if(acctID == null)
    {
        activeAcctID = event[3];
    }
    else if(acctID != null)
    {
        activeAcctID = acctID;
    }

    if(checkInRoomID != '' && checkInRoomID != null && checkInRoomID != undefined)
    {

        //e.preventDefault();

        

        let formData = new FormData();
        //formData.append('user', acctID);
        //formData.append('sessionID', sessionID);
        //formData.append('xImageFile', checkInAttachment_ID);


        let _Tracker = '';
        let _checkInRoomID = '';
        let _checkInRoomID_multiple = '';
        let _bookingID = '';
        let _checkInDateBooked = '';
        let _checkOutDateBooked = '';
        let _checkInNonMemberPaymentAmount_multiple = '';
        let _checkInNonMemberPaymentAmount = '';

        if(checkInCustomerStatus == 'member')
        {
            formData.append('Tracker', 74705);
            formData.append('user', activeAcctID);
            formData.append('xCompanyID_public', props.data.companyID);

            if(props.tracker == 'PUBLIC_74701')
            {
                formData.append('xCheckInRoomID', checkInRoomID);
            }
            else
            {
                formData.append('xCheckInRoomID', props.data.roomID);
            }        
            //formData.append('xCheckInSalesPrice', this.state.checkInSalesPrice);
            formData.append('xSearchGuestData', enterQavaNumberRef.current.value);
            formData.append('xCheckInMemberPaymentType', null);
            formData.append('xCheckInMemberPaymentAmount', paymentAmount);
            formData.append('xCheckInDateBooked', startDate);
            formData.append('xCheckOutDateBooked', endDate);
            //formData.append('xCheckInDateBooked', selectCheckInDateRef.current.value);
            //formData.append('xCheckOutDateBooked', selectCheckOutDateRef.current.value);
            formData.append('xCheckInNumberOfNights', numOfNights);
            formData.append('xBookingType', bookingType);


        }
        else if(checkInCustomerStatus == 'non_member')
    {

        //formData.append('Tracker', 74706);
        //formData.append('user', acctID);
        if(props.tracker == 'PUBLIC_74701')
        {
            if(checkInRoomID_multiple != null)
            {

                _Tracker = '74706_multiple';
                _checkInRoomID_multiple = checkInRoomID_multiple;
            }
            else
            {

                _Tracker = '74706';
                _checkInRoomID = checkInRoomID;
            }
        }
        else
        {

            _Tracker = '74706';
            _checkInRoomID =  props.data.roomID;
        }  

            if(checkInNonMemberPaymentType == 'none')
            {
                if(props.tracker == 'PUBLIC_74701')
                {
                    if(checkInRoomID_multiple != null)
                    {
                        _checkInNonMemberPaymentAmount = roomSalePrice_multiple;

                    }
                    else
                    {

                        _checkInNonMemberPaymentAmount = parseFloat(bookingPrice).toFixed(2);
                    }
                }
                else
                {
                    _checkInNonMemberPaymentAmount = props.data.roomSalePrice;

                }
            } 

            else if(checkInNonMemberPaymentType == 'cash')
            {
                if(props.tracker == 'PUBLIC_74701')
                {
                    if(checkInRoomID_multiple != null)
                    {

                        _checkInNonMemberPaymentAmount = roomSalePrice_multiple;
                    }
                    else
                    {

                        _checkInNonMemberPaymentAmount = parseFloat(bookingPrice).toFixed(2);

                    }
                }
                else
                {

                    _checkInNonMemberPaymentAmount = props.data.roomSalePrice;

                }
            }

    }



        let headers = new Headers();

        const requestOptions = {
            method: 'POST',
            mode: 'no-cors',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('content-type', 'application/json'), 
            body: JSON.stringify({
                Tracker: _Tracker,
                user: activeAcctID,
                xCompanyID_public: props.data.companyID,
                //xCheckInSalesPrice: checkInSalesPrice,
                xCheckInFirstName: enterFirstNameRef.current.value.replace(/\s+/g, '_'),
                xCheckInLastName: enterLastNameRef.current.value.replace(/\s+/g, '_'),
                xCheckInMobileNumber: mobileNumber.replace(/\s+/g, ''),
                xCheckInEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                //xCheckInAttachment_ID: checkInAttachment_ID,
                //xImageFile: checkInAttachment_ID,
                //xCheckInAttachment: checkInAttachment,
                xCheckInCreditCardNumber: enterCC_numberRef.current.value,
                xCheckInCreditCardExpDate: enterCC_expDateRef.current.value,
                xCheckInCreditCardCvvNumber: enterCC_cvvNumberRef.current.value,
                xCheckInCreditCardAddress: enterCC_addressRef.current.value,
                xCheckInCreditCardCity: enterCC_cityRef.current.value,
                xCheckInCreditCardState: enterCC_stateRef.current.value,
                xCheckInCreditCardZipCode: enterCC_zipRef.current.value,
                xCheckInMobileMoneyProvider: selectMobileMoneyProviderRef.current.value,
                xCheckInMobileMoneyPhoneNumber: enterMM_phoneNumberRef.current.value,
                xCheckInBankName: enterChecking_bankNameRef.current.value,
                xCheckInAccountNumber: enterChecking_accountNumberRef.current.value,
                xCheckInRoutingNumber: enterChecking_routingNumberRef.current.value,

                xCheckInNonMemberPaymentType: checkInNonMemberPaymentType,
                xCheckInRoomID: _checkInRoomID,
                xCheckInRoomID_multiple: _checkInRoomID_multiple,
                xCheckInDateBooked: startDate,
                xCheckOutDateBooked: endDate,
                xCheckInNumberOfNights: numOfNights,
                xBookingType: bookingType,
                //xCheckInNonMemberPaymentAmount: _checkInNonMemberPaymentAmount,
                xCheckInNonMemberPaymentAmount: paymentAmount,
                xCheckInNonMemberPaymentAmount_multiple: _checkInNonMemberPaymentAmount_multiple,
                //sessionID: sessionID,
                xCheckInAttachment: checkInAttachment_ID,
    
            }),
        }

        //alert('Inside GetAvaialbleRoom AFTER upload');
        //alert(baseURL);

        let newBaseURL = 'https://ghanaverified.com';
        if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
        {
            newBaseURL = 'https://ghanaverifiedtest.com'
        }


        fetch(baseURL+'ghanaverified/', requestOptions)
        //fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
    

            //setConfirmationManualModal(true);
            //setOpenPayModal(true);

            //closeModalHandler();
    
    
            //props.closeModal();
    
        })

        props.closeModal(false);

    }
    


    else
    {
        //e.preventDefault();

        alert('Please Select Room');
        document.getElementById('searchAvailableRooms').style.border = '3px rgb(245, 5, 5) solid';
    }

}


    function handleSelectPaymentType(e) { 
        e[1].persist(); 
        //alert('In HandleSelectPaymentType');
        //alert(e);

        let event = [e[0], e[1].target.value];

        if(event[0] == 'member')
        {
            setCheckInCustomerStatus(event[0]);  

            if(event[1] == 'member')
            {
                setCheckInMemberPaymentType('none');   
            }
            else if(event[1] == 'cc' || event[1] == 'mm' || event[1] == 'cash' || event[1] == 'checking' )
            {
                setCheckInMemberPaymentType(event[1]);   

            }
        }

        else if(event[0] == 'non_member')
        {
            setCheckInCustomerStatus(event[0]);  

            
            if(event[1] == 'non_member')
            {
                setCheckInNonMemberPaymentType('none');   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'cc')
            {

                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('inline-block');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            } 
            else if(event[1] == 'mm')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('inline-block');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'checking')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('inline-block');   
                setCashInfoDisplay('none');   

            }
            else if(event[1] == 'cash')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('inline-block');   
            } 
        } 

      
    }





function handleMobileNumberChange(e) {

    const input = e.detail.value || '';
    if (!input.startsWith('0')) {
        setErrorMessage('Mobile number must start with 0.');
    } else {
        setErrorMessage('');
    }
    setMobileNumber(input);
    //enterMobileNumberRef.current = input;
};



function confirmGuestBookingHandler(e)
{
    e.preventDefault();

    setOpenPayModal(true);

    //confirmGuestBooking(e);
}

function onCheckInDateHandler(event) {

    // alert("ON CHECK iN DATE HANDLER");
    // alert(event);

    setStartDate(event.startDate);
    setEndDate(event.endDate);
    setNumOfNights(event.numOfNights);

}

function onCheckInRoomIDHandler(event) {

    setBookingType(event.selectedBookingType);
    setCheckInRoomID(event.selectedRoomID);
    setRoomSalePrice(event.selectedRoomSalesPrice);
}


function closeModalHandler() {

    setOpenPayModal(false);

    props.closeModal(false);
}    

//alert(props.data.companyID);

return (
    <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal isOpen={ props.openModal }>
            <form onSubmit={confirmGuestBookingHandler}>
            <IonHeader>

                <SelectRoom openModal={ props.openModal } onCheckInRoomID= { onCheckInRoomIDHandler} onCheckInDate={onCheckInDateHandler} closeModal={closeModalHandler} tracker={'PUBLIC_74701'} data={{
                        companyID: props.data.companyID,
                        }}></SelectRoom>

            </IonHeader>
                
            <IonContent className='checkIn_gridContent'>

                <IonGrid >
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel htmlFor="paymenttype">Payment Type </IonLabel>                                    
                            </IonCol>
                            <IonCol className='ionCol_inputContent'  size='6'>
                                <select name="paymenttype" id='paymenttype' onChange={(e) => handleSelectPaymentType(['non_member', e]) }>
                                    {/*<option value='cc'>Credit Card</option>*/}
                                    <option value='mm'>MOMO MTN ONLY</option>
                                    {/*<option value='checking'>Checking</option>*/}
                                    {/*<option value='cash' selected='selected'>Cash</option>*/}
                                </select>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>First Name: </IonLabel>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size='6'>
                                <IonInput placeholder='Enter' ref={enterFirstNameRef } required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Last Name: </IonLabel>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size='6'>
                                <IonInput placeholder='Enter' ref={enterLastNameRef } required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Mobile Number: </IonLabel>
                            </IonCol>
                            {/*<IonCol className='ionCol_inputContent' size='6'>
                                <IonInput placeholder='Enter' ref={enterMobileNumberRef} required></IonInput>
                            </IonCol>*/}
                            <IonCol className='ionCol_inputContent' size="6">
                            <IonInput
                                id="searchSupplierName"
                                placeholder="Enter mobile number"
                                type="tel"
                                value={mobileNumber}
                                onIonChange={(e) => handleMobileNumberChange(e)}
                                required/>
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Payment Amount: </IonLabel>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size='6'>
                                <IonInput type="decimal" placeholder='Deposit Amount' value={paymentAmount} onIonChange={(e) => setPaymentAmount(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                    <IonRow >
                        <IonCol size='6'>
                            <h4>Amount: </h4>
                        </IonCol>
                        <IonCol size='6'>
                            {/*<IonInput placeholder='Enter Cash Amount' ref={enterCash_amountRef }></IonInput>*/}
                            {props.tracker == 'PUBLIC_74701' ? <h4>{parseFloat(roomSalePrice * numOfNights).toFixed(2)}</h4> : <h4>{parseFloat(props.data.roomSalePrice * numOfNights).toFixed(2)}</h4>}
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>

            <IonFooter >
                <IonButton type='submit' className='grid_checkInFooter_left' > Confirm Booking </IonButton>
                {/*<IonButton className='grid_checkInFooter_left' onClick={() => confirmGuestBookingHandler()}> Confirm Booking </IonButton>*/}
                <IonButton onClick={() => closeModalHandler()} className='grid_checkInFooter_right'> Cancel </IonButton>
            </IonFooter>
            </form>

            </IonModal>
            ) : null}


            {openPayModal == true && <PayModal openModal={ openPayModal } closeModal={(event) => confirmGuestBooking(event)} payCloseModal={() => setOpenPayModal(false)} data={{
                    companyId: props.data.companyID,
                    mtnCompanyPhoneNumber: props.data.mtnCompanyPhoneNumber,
                    roomID: checkInRoomID,
                    numOfNights: numOfNights,
                    firstName: enterFirstNameRef.current.value, 
                    lastName: enterLastNameRef.current.value,
                    mobileNumber: mobileNumber,
                    payeeMessage: 'Bluefin Hotel Booking Payment',
                    bookedStartDate: startDate,
                    bookedEndDate: endDate,
                    roomGuestPrice: roomSalePrice,
                    subTotal: paymentAmount,
                    payment_amount: paymentAmount,
                    }}></PayModal>}


    </React.Fragment>)
}